import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";
import { createExpense, getExpense, updateExpense,fetchExpenseCategoriesApi } from "../../../service/expensesService";
import  Select  from "react-select";
import { format} from 'date-fns';
import Swal from 'sweetalert2';

const ExpenseModal = ({onExpenseAdded, expenseId}) => {

  const [expenseDate, setExpenseDate] = useState(null);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [data, setData]=useState(null)
  
  

  const handleDateChangeModal = (date) => {
    setExpenseDate(date);

    setFormData((prevData) => ({
      ...prevData,
      expenseDate: date,
  }));
  };

  const [formData, setFormData] = useState({
    expenseCategory: "",
    expenseDate: "",
    expenseAmount: 0,
    expenseState: true,
    expenseFor: "",
    expenseDescription: "",

  });

  // console.log(CustomerModal)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const setSelectedExpense = async (expenseId) => {
    try {
      const response = await getExpense(expenseId);


      const date = response.data.data.expense.expenseDate;
      setExpenseDate(new Date(date))
      console.log(expenseDate,"Expense Date")
      setData(response.data.data.expense)

      if (response.data) {
        const { expenseCategory, expenseDate, expenseAmount, expenseState, expenseFor, expenseDescription } = response.data.data.expense;
        setFormData({
          ...formData,
          expenseCategory,
          expenseDate,
          expenseAmount,
          expenseState,
          expenseFor,
          expenseDescription,
        });
        
        console.log(formData.expenseCategory,"category PPPP")
        //setExpenseDate(response.data.data.expense.expenseDate)  
      } else {
        console.error("Failed to fetch Expense data");
      }
    } catch (error) {
      console.error("Error fetching Expense data:", error);
    }
  };

  useEffect(() => {
    if (expenseId) {
      setSelectedExpense(expenseId);
    }
  }, [expenseId]);
    

  const handleCancel=()=>{
    setFormData({
      expenseCategory: "",
      expenseDate: "",
      expenseAmount: 0,
      expenseState: true,
      expenseFor: "",
      expenseDescription: "",
    });
    setExpenseDate(null)
  }
  const handleReset=()=>{
    if(expenseId){
      const date = data.expenseDate;
      setExpenseDate(new Date(date))

        const { expenseCategory, expenseDate, expenseAmount, expenseState, expenseFor, expenseDescription } = data;
        setFormData({
          ...formData,
          expenseCategory,
          expenseDate,
          expenseAmount,
          expenseState,
          expenseFor,
          expenseDescription,
    });
        
  }
  }


const handleUpdateSubmit = async (e) => {
  e.preventDefault();

  
  const { expenseCategory, expenseAmount, expenseDescription } = formData;

  if (!expenseCategory || !expenseAmount || !expenseDescription || !expenseDate) {
    Swal.fire({
      icon: 'warning',
      title: 'Missing Fields',
      text: 'Please fill in all required fields before submitting.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'OK',
    });
    return; 
  }

  
  const today = new Date();
  const selectedDate = new Date(expenseDate); 
  if (selectedDate > today) {
    Swal.fire({
      icon: 'warning',
      title: 'Invalid Date',
      text: 'The expense date cannot be in the future. Please select today or an earlier date.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'OK',
    });
    return; 
  }

  try {
    const formattedDate = expenseDate ? format(expenseDate, "dd/MM/yyyy") : "";

    const expenseData = {
      ...formData,
      expenseDate: formattedDate,
      expenseAmount: parseFloat(expenseAmount), 
    };

    console.log(expenseData, "This is Edit data");
    console.log(expenseId, "This is Edit ID");

    const response = await updateExpense(expenseId, expenseData);

    console.log("Expense updated successfully:", response);

    // Display SweetAlert
    Swal.fire({
      title: 'Success!',
      text: 'Expense updated successfully!',
      icon: 'success',
      confirmButtonText: 'Okay',
    });

    setFormData({
      expenseCategory: "",
      expenseDate: "",
      expenseAmount: 0,
      expenseState: true,
      expenseFor: "",
      expenseDescription: "",
    });
    setExpenseDate(null);

    onExpenseAdded();

  } catch (error) {
    console.error("Error updating Expense:", error);

    // Optionally, you can also display an error alert
    Swal.fire({
      title: 'Error!',
      text: 'There was an error updating the expense.',
      icon: 'error',
      confirmButtonText: 'Okay',
    });
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const { expenseCategory, expenseAmount, expenseDescription } = formData;
  
    if (!expenseCategory || !expenseAmount || !expenseDescription || !expenseDate) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Fields',
        text: 'Please fill in all required fields before submitting.',
        allowOutsideClick: false, 
        allowEscapeKey: false,
        confirmButtonText: 'OK',
      });
      return; 
    }
  
    const today = new Date();
    const selectedDate = new Date(expenseDate); 
  
    if (selectedDate > today) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Date',
        text: 'The expense date cannot be in the future. Please select today or an earlier date.',
        allowOutsideClick: false, 
        allowEscapeKey: false,
        confirmButtonText: 'OK',
      });
      return;
    }
  
    try {
      const formattedDate = expenseDate ? format(expenseDate, "dd/MM/yyyy") : "";
  
      const expenseData = {
        ...formData,
        expenseDate: formattedDate,
        expenseAmount: parseFloat(expenseAmount), 
      };
  
      console.log(expenseData, "Handle submit save DATA");
      const response = await createExpense(expenseData);
      console.log(response);
  
      Swal.fire({
        icon: 'success',
        title: 'Expense Added',
        text: 'Your expense has been added successfully!',
        confirmButtonText: 'OK',
      });
  
      onExpenseAdded();
      console.log("Expense added successfully:", response.data);
  
      setFormData({
        expenseCategory: "",
        expenseDate: "",
        expenseAmount: 0,
        expenseState: true,
        expenseFor: "",
        expenseDescription: "",
      });
      setExpenseDate(null);
      
    } catch (error) {
      console.error("Error adding expense:", error);
  
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'There was an error adding the expense. Please try again.',
        confirmButtonText: 'OK',
      });
    }
  };
  
  useEffect(() => {
    fetchExpenseCategories();
  }, []);

 //fetch categories
  const fetchExpenseCategories = async () => {
    try {
      const data = await fetchExpenseCategoriesApi();
      console.log(data);
      
      const options = data.data.expenseCategory.map((category) => ({
        label: category.expenseCategoryName,
        value: category._id,
      }));
      console.log(options,"this is options")
      
      setExpenseCategories(options);
    } catch (error) {
      console.error("Error fetching Expense Categories:", error);
    }
  };


  return (
    <div>
      {/* Add Expense */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add Expense</h4>
                  </div>
                 
                </div>
                <div className="modal-body custom-modal-body">
                  <form >
                    <div className="row">
                        <div className="col-lg-6">
                        <div className="mb-3">
                          <label className="form-label">Expense Category</label>
                          <Select
                            options={expenseCategories}
                            placeholder="Choose Category"
                            value={expenseCategories.find(option => option.value === formData.expenseCategory) || null} // Set value based on state
                            onChange={(selectedOption) => setFormData((prevData) => ({
                              ...prevData,
                              expenseCategory: selectedOption ? selectedOption.value : "", // Ensure it sets to empty if null
                            }))}
                            required
                          />

                        
                        </div>
                        </div>
                        <div className="col-lg-6">
                        <div className="input-blocks date-group">
                            <i data-feather="calendar" className="info-img" />
                            <div className="input-groupicon">
                            <DatePicker
                                name="expenseDate"
                                selected={expenseDate}
                                onChange={handleDateChangeModal}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Choose Date"
                                className="datetimepicker"
                                required
                            />
                            </div>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-lg-8">
                            <div className="mb-3">
                            <label className="form-label">Amount</label>
                            <input
                                type="text"
                                className="form-control"
                                name="expenseAmount"
                                value={formData.expenseAmount}
                                onChange={handleChange}
                               // placeholder="$"
                                required
                            />
                            </div>
                        </div>
                        <div className="col-lg-4">
                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                          <span className="form-label">Status</span>
                          <input
                            type="checkbox"
                            id="user2"
                            className="check"
                            name="expenseState"
                            checked={formData.expenseState} // Bind to `expenseState`
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                expenseState: e.target.checked, // Update state based on checkbox value
                              }));
                            }}
                            required
                          />
                          <label htmlFor="user2" className="checktoggle" /> 
                        </div>
                        </div>
                        </div>
                                                    
                        {/* Editor */}
                        <div className="col-md-12">
                        <div className="edit-add card">
                            <div className="edit-add">
                            <label className="form-label">Description</label>
                            </div>
                            <div className="card-body-list input-blocks mb-0">
                            <textarea
                                className="form-control mb-1"
                                name="expenseDescription"
                                value={formData.expenseDescription}
                                onChange={handleChange}
                                required
                            />
                            </div>
                            <p>Maximum 600 Characters</p>
                        </div>
                        </div>
                        {/* /Editor */}
                    </div>
                   
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",

                    }} className="mt-4" >
                      <button
                        type="button"
                        className="btn btn-cancel"
                        data-bs-dismiss="modal"
                        onClick={handleCancel}
                      >
                        Close
                      </button>
                      <div>
                        <button
                          type="button"
                          className="btn btn-reset me-2"
                        onClick={handleCancel}
                        >
                          Reset
                        </button>
                        <button
                          type="button"
                          className="btn btn-submit"
                          onClick={handleSubmit}
                          data-bs-dismiss="modal"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Expense */}

      {/* Edit Expense */}
      <div className="modal fade" id="edit-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Expense</h4>
                  </div>
                 
                </div>
                <div className="modal-body custom-modal-body">
                  <form >
                    <div className="row">
                        <div className="col-lg-6">
                        <div className="mb-3">
                          <label className="form-label">Expense Category</label>
                          <Select
                            options={expenseCategories}
                            value={expenseCategories.find(option => option.value === formData.expenseCategory._id)}
                            onChange={(selectedOption) => setFormData((prevData) => ({
                              ...prevData,
                              expenseCategory: selectedOption.value,
                            }))}
                            placeholder="Choose"
                            required
                             
                            
                            
                          />
                        </div>
                        </div>
                        <div className="col-lg-6">
                        <div className="input-blocks date-group">
                            <i data-feather="calendar" className="info-img" />
                            <div className="input-groupicon">
                            <DatePicker
                                name="expenseDate"
                                selected={expenseDate}
                                onChange={handleDateChangeModal}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Choose Date"
                                className="datetimepicker"
                                required
                            />
                            </div>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-lg-8">
                            <div className="mb-3">
                            <label className="form-label">Amount</label>
                            <input
                                type="text"
                                className="form-control"
                                name="expenseAmount"
                                value={formData.expenseAmount}
                                onChange={handleChange}
                                
                                required
                            />
                            </div>
                        </div>
                        <div className="col-lg-4">
                        <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                          <span className="form-label">Status</span>
                          <input
                            type="checkbox"
                            id="user2"
                            className="check"
                            name="expenseState"
                            checked={formData.expenseState} // Bind to `expenseState`
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                expenseState: e.target.checked, // Update state based on checkbox value
                              }));
                            }}
                            required
                          />
                          <label htmlFor="user2" className="checktoggle" /> 
                        </div>
                        </div>
                        </div>
                                                        
                        {/* Editor */}
                        <div className="col-md-12">
                        <div className="edit-add card">
                            <div className="edit-add">
                            <label className="form-label">Description</label>
                            </div>
                            <div className="card-body-list input-blocks mb-0">
                            <textarea
                                className="form-control mb-1"
                                name="expenseDescription"
                                value={formData.expenseDescription}
                                onChange={handleChange}
                                required
                            />
                            </div>
                            <p>Maximum 600 Characters</p>
                        </div>
                        </div>
                        {/* /Editor */}
                    </div>
                  
                    <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",

                    }} className="mt-4" >
                      <button
                        type="button"
                        className="btn btn-cancel"
                        data-bs-dismiss="modal"
                        onClick={handleCancel}
                      >
                        Close
                      </button>
                      <div>
                        <button
                          type="button"
                          className="btn btn-reset me-2"
                        onClick={handleReset}
                        >
                          Reset
                        </button>
                        <button
                          type="button"
                          className="btn btn-submit"
                          onClick={handleUpdateSubmit}
                          data-bs-dismiss="modal"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Expense */}
    </div>
  );
};

ExpenseModal.propTypes = {
    onExpenseAdded: PropTypes.func.isRequired,
    expenseId: PropTypes.string,
  };

export default ExpenseModal;
